import React from "react";

const InfoSection3 = () => {
  return (
    <section className="info3-section" id="network-scroll">
      <div className="info3-container">
        <div className="info3-left">
          <p className="info3-badge">TOP-TALENT-NETZWERK</p>
          <h2 className="info3-title">
            Zugang zu den besten Talenten der<br></br><span className="highlight">Top 100 Business Universitäten</span> Europas.
          </h2>
          <p className="info3-description">
            Wir arbeiten eng mit renommierten europäischen Hochschulen und Business Schools zusammen, um frühzeitig Zugang zu herausragenden Nachwuchstalenten zu schaffen. Durch gezieltes Scouting, persönliche Auswahlprozesse und datenbasiertes Matching bringen wir Ihr Projekt mit den besten Köpfen aus Wirtschaft, Tech und Innovation zusammen.
          </p>
        </div>

        <div className="info3-right">
          <div className="info3-fact">
            <img src="/assets/briefcase-fill.svg" alt="Berufserfahrung" className="info3-icon-img" />
            <div>
              <h3 className="info3-fact-title">100 % mit Berufserfahrung</h3>
              <p className="info3-fact-text">Viele unserer Talente haben praktische Erfahrung aus Start-ups, Beratung oder Industrie.</p>
            </div>
          </div>
          <div className="info3-fact">
            <img src="/assets/shirt-folded-fill.svg" alt="Berufserfahrung" className="info3-icon-img" />
            <div>
              <h3 className="info3-fact-title">Senior Experts on Demand</h3>
              <p className="info3-fact-text">Ehemalige C-Level-Führungskräfte bringen tiefes Fachwissen gezielt in Projekte ein.</p>
            </div>
          </div>
          <div className="info3-fact">
            <img src="/assets/chart-line-up-fill.svg" alt="Berufserfahrung" className="info3-icon-img" />
            <div>
              <h3 className="info3-fact-title">Kontinuierliches Wachstum</h3>
              <p className="info3-fact-text">Stetig wachsendes Netzwerk an Freelancern mit akademischem Hintergrund.</p>
            </div>
          </div>
          <div className="info3-fact">
            <img src="/assets/book-bookmark-fill.svg" alt="Berufserfahrung" className="info3-icon-img" />
            <div>
              <h3 className="info3-fact-title">Nur Top 100 Hochschulen</h3>
              <p className="info3-fact-text">Alle Talente stammen aus Hochschulen des FT Business School Rankings 2024.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InfoSection3;
